import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

/** 레거시 .pb-20.mb-10 블록(비용구분·지급 정보) */
export const ExpenseSection = styled(Box)({
  marginBottom: APPROVAL_SECTION_GAP,
});

/** 업체 블록 삭제 버튼 자리(레거시 우상단 top 15 / right 20). 버튼은 포탈 TextButton */
export const VendorDeleteSlot = styled(Box)({
  position: 'absolute',
  top: 15,
  right: 20,
});

/** 업체 추가·지급 총액 계산 줄(레거시 .d-flex.justify-content-end.mb-40, gap 10) */
export const ActionRow = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  marginBottom: 40,
});
